import { Hidden } from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ContentSpacer } from '../../global/components/layout/generic-content-spacer';
import { buttonStyles } from '../../global/constants/theme/styles/components/buttonstyles';
import { sortTableStyles } from '../../global/constants/theme/styles/tables/generic-sort-table';
import { getEmployerChangeLogDetail } from '../../global/ducks/benefit-group-change-log-api';
import { formatDateWithHourAndMinutes, getFormattedDate } from '../../global/helpers/date-helpers';
import { getPhoneFormat } from '../../global/helpers/format-helpers';
import { LabelSettingProps } from '../../global/models/epi-model';
import { SearchProps } from '../../pages/arc/models/arc-epi-props';
import { TcsmStates } from '../../root/tcsm-model';
import { mapEventType } from '../change-log/change-log-requests';
import { BenefitGroupChangeLogItem } from '../models/benefit-group-changelog-models';

interface ChangeItem {
	previous_value: string;
	new_value: string;
	field: string;
}


interface Props {
	item: BenefitGroupChangeLogItem,
	setOpen: (open) => void;
	setContent: (content) => void;
	settings: SearchProps;
}


export function BenefitGroupChangeLogItemView(props: Props) {
	const tableClasses = sortTableStyles();
	const { item, settings } = props;
	const dispatch = useDispatch();
	const buttonClasses = buttonStyles();
	const labelSettings = useSelector<TcsmStates, LabelSettingProps>(state => state?.epiProps?.labelSettingState?.epiContent);

	const onClick = (content) => {
		props?.setContent(content);
		props?.setOpen(true);
	};


	const lastActivityDate = formatDateWithHourAndMinutes(new Date(item.change_time));

	function GetRequestedByContent(selectedItem: BenefitGroupChangeLogItem) {
		return (
			<>
				<h3 className='modal-content-title'>{settings?.requestByLabel}</h3>
				<div>{selectedItem?.requestorFirstName} {selectedItem?.requestorLastName}</div>
				<div>{selectedItem?.requestorEmail}</div>
				{selectedItem?.requestorUserPhoneNumber &&
					<div>{getPhoneFormat(
						selectedItem?.requestorUserPhoneCountryCode,
						selectedItem?.requestorUserPhoneAreaCode,
						selectedItem?.requestorUserPhoneNumber,
						selectedItem?.requestorUserPhoneExtension,
						labelSettings?.extensionLabel)}</div>}
			</>
		);
	}
	function Labels() {
		return (
			<div className='sort-table-row'>
				<div className='sort-table-row-cell'><p><strong>{settings?.fieldInformationLabel}</strong></p></div>
				<div className='sort-table-row-cell'><p><strong>{settings?.previousLabel}</strong></p></div>
				<div className='sort-table-row-cell'><p><strong>{settings?.changedToLabel}</strong></p></div>
			</div>
		);
	}

	function GetGroupedSections(data: ChangeItem[]) {
		const result = {};
		data?.forEach(
			d => {
				const mappedSection = settings?.benefitGroupChangeLogSectionMapping?.filter(a => a?.value?.split(',').includes(d?.field))[0];
				const key = mappedSection?.key || settings?.benefitGroupDetailDefaultSectionTitle;
				if (result[key])
					result[key].push(d);
				else
					result[key] = [d];
			},
		);

		return result;
	}

	function GetLastActivityContent(selectedItem: BenefitGroupChangeLogItem, data: ChangeItem[]) {

		const groupedSections = GetGroupedSections(data);

		return (
			<>
				<h3 className='modal-content-title'>{settings?.lastActivityDateLabel}</h3>
				<h3 className='modal-content-title'>{selectedItem?.changeMadeFor} - {lastActivityDate}</h3>
				{
					Object.keys(groupedSections)?.map((k, idx) => {
						return (
							<div key={`${idx}-${k}`} >
								<ContentSpacer>
									<h4>{k}</h4>
								</ContentSpacer>
								<ContentSpacer>
									<div className={tableClasses.sortTable}>
										<Hidden xsDown>
											<Labels />
										</Hidden>
										<div className='sort-table-content'>
											{
												groupedSections[k]?.map((a, subIdx) => {
													const mappedFieldName = settings?.benefitGroupChangeLogKeyValuePair?.filter(kvp => kvp?.key === a?.field)[0];
													return (
														<div className='sort-table-row' key={`${subIdx}-${a?.field}`} >
															<div className='sort-table-row-cell'><p>{mappedFieldName?.value || a?.field}</p></div>
															<div className='sort-table-row-cell'><p>{a?.previous_value}</p></div>
															<div className='sort-table-row-cell'><p>{a?.new_value}</p></div>
														</div>
													);
												})
											}
										</div>
									</div>
								</ContentSpacer>
							</div>
						);
					})
				}
			</>
		);
	}


	function RenderUserFriendlySummary(summaryValue: string) {
		if (!summaryValue) return null;

		const values: string[] = summaryValue?.split(';');

		return (
			<>
				{values.map(eventDescription => <p>{mapEventType(eventDescription, settings?.eventTypeMappingBenefitsGroup)}</p>)}
			</>);
	}

	const getChangeLogDetail = () => {
		dispatch(getEmployerChangeLogDetail(item?.id, (res) => {
			props?.setOpen(true);
			props?.setContent(GetLastActivityContent(item, res?.data));
		}));
	};

	return (
		<div className='sort-table-row sort-table-row-tablet-split'>
			<Hidden mdDown>
				<div className='sort-table-row-cell'>
					<p>{getFormattedDate(item?.submittedDate)}</p>
				</div>
				<div className='sort-table-row-cell'>
					<button className={buttonClasses.linkButton} type='button' onClick={getChangeLogDetail}>{lastActivityDate}</button>
				</div>
				<div className='sort-table-row-cell'>
					<p>{item?.status}</p>
				</div>
				<div className='sort-table-row-cell sort-table-row-cell-lg'>
					<div className='rich-text'>{RenderUserFriendlySummary(item?.eventType)}</div>
				</div>

				<div className='sort-table-row-cell'>
					<button className={buttonClasses.linkButton} type='button' onClick={() => onClick(GetRequestedByContent(item))}>{item?.requestedBy}</button>
				</div>
				<div className='sort-table-row-cell'>

					<p>{item?.completed}</p>
				</div>
				<div className='sort-table-row-cell'>
					<p>{item?.changeMadeFor}</p>
					<p>{settings?.shortenedClientNumberLabel} {item?.changeMadeForCn}</p>
				</div>
				<div className='sort-table-row-cell'>

					<p>{item?.changeType}</p>
				</div>
			</Hidden>

			<Hidden lgUp>

				<div className='sort-table-row-tablet-split-column'>
					<div className='sort-table-row-cell'>
						<Hidden lgUp>
							<p><strong>{props.settings?.submittedDateLabel}</strong></p>
						</Hidden>
						<p>{getFormattedDate(item?.submittedDate)}</p>
					</div>
					<div className='sort-table-row-cell'>
						<Hidden lgUp>
							<p><strong>{props.settings?.lastActivityDateLabel}</strong></p>
						</Hidden>
						<button className={buttonClasses.linkButton} type='button' onClick={getChangeLogDetail}>{lastActivityDate}</button>
					</div>
					<div className='sort-table-row-cell'>
						<Hidden lgUp>
							<p><strong>{props.settings?.statusRowLabel}</strong></p>
						</Hidden>
						<p>{item?.status}</p>
					</div>
					<div className='sort-table-row-cell'>
						<Hidden lgUp>
							<p><strong>{props.settings?.eventTypeLabel}</strong></p>
						</Hidden>
						<div className='rich-text'>{RenderUserFriendlySummary(item?.eventType)}</div>
					</div>
				</div>
				<div className='sort-table-row-tablet-split-column'>
					<div className='sort-table-row-cell'>
						<Hidden lgUp>
							<p><strong>{props.settings?.requestByLabel}</strong></p>
						</Hidden>
						<button className={buttonClasses.linkButton} type='button' onClick={() => onClick(GetRequestedByContent(item))}>{item?.requestedBy}</button>
					</div>
					<div className='sort-table-row-cell'>
						<Hidden lgUp>
							<p><strong>{props.settings?.completedLabel}</strong></p>
						</Hidden>
						<p>{item?.completed}</p>
					</div>
					<div className='sort-table-row-cell'>
						<Hidden lgUp>
							<p><strong>{props.settings?.changeMadeForLabel}</strong></p>
						</Hidden>
						<p>{item?.changeMadeFor}</p>
					</div>
					<div className='sort-table-row-cell'>
						<Hidden lgUp>
							<p><strong>{props.settings?.changeTypeLabel}</strong></p>
						</Hidden>
						<p>{item?.changeType}</p>
					</div>
				</div>
			</Hidden>
		</div>


	);
}